@if (criteria.length) {
  <div class="gridky-criteria">
    <span class="fw-600 fs-12"
      >LES CRITÈRES QUI RENDENT CE BIEN EXCEPTIONNEL</span
    >
  </div>
}
@for (criteria of criteria; track criteria) {
  <div class="gridky-criteria-list">
    <div class="gridky-criteria">
      <p>{{ criteria.label | uppercase }}</p>
      <pr-label
        [name]="criteria.icon"
        [viewBoxHeight]="25"
        [viewBoxWidth]="25"
        >{{ criteria.value }}</pr-label
      >
    </div>
  </div>
}
